import React from 'react';
import { Search, Users, Zap, RefreshCw, Anchor } from 'lucide-react';

export const RFFFlowDiagram = () => {
  const phases = [
    {
      number: 1,
      icon: Search,
      title: 'Resonanz-Diagnose',
      subtitle: 'Flow-Start',
      description: 'Systematische Analyse Ihrer Ausgangssituation',
      color: 'from-purple-600 to-purple-700',
      duration: '1-2 Wochen'
    },
    {
      number: 2,
      icon: Users,
      title: 'Coalition-Building',
      subtitle: 'Flow-Design',
      description: 'Roadmap entwickeln, Stakeholder einbinden',
      color: 'from-blue-600 to-blue-700',
      duration: '1-3 Wochen'
    },
    {
      number: 3,
      icon: Zap,
      title: 'Agile Iteration',
      subtitle: 'Flow-Activation',
      description: 'Umsetzung in flexiblen Sprints',
      color: 'from-orange-500 to-orange-600',
      duration: '4-12 Wochen'
    },
    {
      number: 4,
      icon: RefreshCw,
      title: 'Feedback Loops',
      subtitle: 'Flow-Harmonization',
      description: 'Kontinuierliche Anpassung',
      color: 'from-emerald-500 to-emerald-600',
      duration: 'Laufend'
    },
    {
      number: 5,
      icon: Anchor,
      title: 'Anchoring',
      subtitle: 'Flow-Sustainment',
      description: 'Nachhaltige Verankerung',
      color: 'from-violet-500 to-violet-600',
      duration: '1-3 Monate'
    }
  ];

  return (
    <div className="relative py-16">
      {/* Flow River */}
      <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-purple-200 via-blue-200 via-orange-200 via-emerald-200 to-violet-200 transform -translate-y-1/2 hidden lg:block" />
      
      {/* Phases */}
      <div className="relative grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {phases.map((phase, index) => (
          <div key={index} className="text-center group">
            {/* Icon Circle */}
            <div className="relative mb-6">
              <div className={`w-20 h-20 mx-auto rounded-full bg-gradient-to-br ${phase.color} flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110`}>
                <phase.icon className="w-10 h-10 text-white" />
              </div>
              {/* Phase Number */}
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center border-2 border-slate-200">
                <span className="text-sm font-bold text-slate-700">{phase.number}</span>
              </div>
            </div>
            
            {/* Content */}
            <div className="space-y-2">
              <h3 className="text-lg font-semibold text-slate-900">
                {phase.title}
              </h3>
              <p className={`text-sm font-medium bg-gradient-to-r ${phase.color} bg-clip-text text-transparent`}>
                {phase.subtitle}
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                {phase.description}
              </p>
            </div>
            
            {/* Arrow Connector (hidden on mobile) */}
            {index < phases.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                <svg width="32" height="32" viewBox="0 0 32 32" className="text-slate-300">
                  <path d="M8 16 L24 16 M20 12 L24 16 L20 20" stroke="currentColor" strokeWidth="2" fill="none" />
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
      
      {/* Info Box */}
      <div className="mt-12 p-6 bg-slate-50 rounded-2xl border border-slate-200">
        <p className="text-center text-sm text-slate-600 leading-relaxed">
          <span className="font-semibold text-slate-900">Resonance Flow Framework:</span> Ein fließender, adaptiver Prozess – kein starrer Plan. 
          Wir passen uns Ihrem Tempo und Ihren Bedürfnissen an.
        </p>
      </div>
    </div>
  );
};
